import { useEffect, useState } from "react";
import { Table, DatePicker } from "antd";
import { useTranslation } from "react-i18next";

import axios from "axios";
import { apiUrl } from "../config";

export default function StokTable() {
    const [modifiedData, setModifiedData] = useState([]);
    const [allData, setAllData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [archiveDate, setArchiveDate] = useState("")
    const { t } = useTranslation();


    const username = process.env.REACT_APP_USERNAME;
    const password = process.env.REACT_APP_SECRET_KEY;

    const getData = () => {
        setLoading(true)
        axios.get(`${apiUrl}/getDailyStockManagement`, {
            auth: {
                username: username,
                password: password
            }
        })
            .then((response) => setAllData(response.data.filter(item => !item.material_description.includes("Gövde Ön"))))
            .catch((error) => console.log(error))
        setLoading(false)
    }

    // console.log(allData.filter(item=> item.material_description.includes("Gövde Ön")))
    const getDataArchive = () => {
        setLoading(true)
        axios.get(`${apiUrl}/getStockManagementAtDate/${(archiveDate)}`, {
            auth: {
                username: username,
                password: password
            }
        })
            .then((response) => setAllData(response.data.filter(item => !item.material_description.includes("Gövde Ön"))))
            .catch((error) => console.log(error))
        setLoading(false)
    }

    useEffect(() => {
        setAllData([])
        if (archiveDate) getDataArchive()
        else getData();

    }, [archiveDate]);

    useEffect(() => {
        const dataList = allData?.map((item, index) => ({
            key: index + 1,
            material_description: item?.material_description,
            stock_amount: item?.stock_amount,
            date: item?.date,
            malzeme_kodu: item?.malzeme_kodu,
        }));

        setModifiedData([...dataList]);
    }, [allData]);
    const handleTableChange = (pagination, filters, sorter, currentTable) => {
        // console.log('Various parameters', pagination, filters, sorter);
        // setFilteredInfo(filters);
        // setSortedInfo(sorter);
        // setCurrentTable(currentTable?.currentDataSource)
    };

    const onChange = (date, dateString) => {
        setArchiveDate(dateString);
    };
    const columns = [
        {
            title: t("uretim.date"),
            dataIndex: "date",

            key: "date",
            align: "center",
            width: 180,
        },
        {
            title: t("stok.materialCode"),
            dataIndex: "malzeme_kodu",

            key: "malzeme_kodu",
            align: "center",
            width: 180,
        },
        {
            title: t("uretim.materialName"),
            dataIndex: "material_description",

            key: "material_description",
            align: "center",
            width: 180,
        },
        {
            title: t("uretim.productionQuantity"),
            dataIndex: "stock_amount",

            key: "stock_amount",
            align: "center",
            width: 180,
        },

        // },

    ];

    return (
        <div className="flex min-w-0 flex-1 flex-col gap-2">

            <div className="text-center p-2 shadow-md bg-labelColor font-bold rounded-md justify-between flrx flex-col " >
                <h2 className="text-lg">{t("uretim.bodyProductionQuantity")}</h2>
                <div><DatePicker placeholder={t("uretim.selectDate")} onChange={onChange} /></div>
            </div>

            <div className="tableAsma flex min-w-0 w-full">

                <Table
                    // className="table-main1"
                    bordered
                    sticky
                    loading={loading}
                    dataSource={modifiedData}
                    rowClassName={(record, index) => {
                        return record.is_started_asma === true ||
                            record.is_completed_asma === true
                            ? "table-first-item table-height"
                            : index % 2 === 0
                                ? "table-row-light table-height"
                                : "table-row-dark table-height";
                    }}

                    onChange={handleTableChange}
                    columns={columns}
                    pagination={{ pageSize: 50 }}
                    scrollToFirstRowOnChange={true}
                    className="w-full"
                    scroll={{ x: "max-content" }}


                />
            </div>
        </div>
    );
}
